import {
  PermissionContext,
  permissionsOperations,
} from '@ardoq/access-control';
import { FeatureContext, featureOperations, Features } from '@ardoq/features';
import { PrivilegeLabel } from '@ardoq/api-types';

/**
 * Given a permission context, checks if the user has access to customer
 * support chat
 *
 * @Note This is a temporary utility that will be replaced with the correct
 * `permissionsOperations.hasPrivilege` check once we deprecate the respective
 * feature flags.
 */
export const hasAccessToSupportChat = (
  permissionContext: PermissionContext,
  featureContext: FeatureContext
): boolean => {
  if (
    featureOperations.hasFeature(featureContext, Features.DISABLED_INTERCOM)
  ) {
    return false;
  }

  if (permissionContext.user?.impersonatedBy) {
    return false;
  }

  if (
    !featureOperations.hasFeature(
      featureContext,
      Features.ACCESS_CUSTOMER_SUPPORT_CHAT_PRIVILEGE
    )
  ) {
    return true;
  }

  return permissionsOperations.hasPrivilege(
    permissionContext,
    PrivilegeLabel.ACCESS_CUSTOMER_SUPPORT_CHAT
  );
};
